import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import * as actionCreators from '../../store/actions';
import {unmountReactNode} from '../../helpers/reactDomCompat';

const propTypes = {
  noOverlay: PropTypes.bool,
  portal: PropTypes.bool,
  closeEvent: PropTypes.func,
  className: PropTypes.string,
  titleHtml: PropTypes.element,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  children: PropTypes.element.isRequired,
  onEscape: PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.func]),
  setPopupState: PropTypes.func.isRequired,
  addBodyClasses: PropTypes.bool,
  parent: PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.instanceOf(Element)]),
  closeButton: PropTypes.bool,
};

const defaultProps = {
  noOverlay: false,
  portal: false,
  closeEvent: () => {},
  className: '',
  titleHtml: null,
  title: '',
  onEscape: null,
  addBodyClasses: true,
  parent: null,
  closeButton: true,
};
class PopupBase extends Component {
  constructor(props) {
    super(props);
    this.close = this.close.bind(this);
    this.handlerEsc = this.handlerEsc.bind(this);
    this.parent = props.parent || document.getElementById('popup-container');
  }

  componentDidMount() {
    const {setPopupState, addBodyClasses, portal} = this.props;
    window.addEventListener('keydown', this.handlerEsc, true);
    if (addBodyClasses) {
      document.body.classList.add('popup-added');
    }
    const {noOverlay} = this.props;
    if (noOverlay) {
      document.body.classList.add('popup-no-overlay');
    }
    if (!portal && this.parent) {
      this.parent.classList.add('open');
    }
    setPopupState(true);
  }

  componentWillUnmount() {
    const {setPopupState, addBodyClasses} = this.props;
    window.removeEventListener('keydown', this.handlerEsc, true);
    if (addBodyClasses) {
      document.body.classList.remove('popup-added');
    }
    const {noOverlay} = this.props;
    if (noOverlay) {
      document.body.classList.remove('popup-no-overlay');
    }
    setPopupState(false);
  }

  close() {
    const {closeEvent, portal} = this.props;
    if (!portal) {
      unmountReactNode(this.parent);
      this.parent.classList.remove('open');
    }
    closeEvent();
  }

  handlerEsc(evt) {
    const {onEscape} = this.props;
    let isEscape = false;
    if ('key' in evt) {
      isEscape = evt.key === 'Escape' || evt.key === 'Esc';
    }
    else {
      isEscape = evt.keyCode === 27;
    }
    if (isEscape) {
      if (onEscape) {
        const close = onEscape();
        if (close) {
          this.close();
        }
      }
      else {
        this.close();
      }
    }
  }

  render() {
    const {
      className, noOverlay, titleHtml, title, children, closeButton,
    } = this.props;
    return (
      <React.Fragment>
        {!noOverlay && <div className={`popup-overlay${className ? ` ${className}-overlay` : ''}`} />}
        <div className={className ? `popup ${className}` : 'popup'}>
          <div className="popup-header">
            {(titleHtml || title) && (
              <h3>
                {titleHtml}
                {title}
              </h3>
            )}
            {closeButton && (
              <button type="button" className="button-link close" aria-label="Close" onClick={() => this.close()}>
                <i className="icon-b icon-b-close" />
              </button>
            )}
          </div>
          <div className="popup-content">{children}</div>
        </div>
      </React.Fragment>
    );
  }
}

PopupBase.defaultProps = defaultProps;
PopupBase.propTypes = propTypes;

const mapDispatchToProps = dispatch => ({
  setPopupState: state => dispatch(actionCreators.setPopupState(state)),
});

export default connect(null, mapDispatchToProps, null, {forwardRef: true})(PopupBase);
